import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue' 
import { layer } from '@layui/layer-vue'
import { addPlatform,allPlatform,abnormalOrders,addConfig,getConfig } from '../../api'
  

  

export default /*#__PURE__*/_defineComponent({
  __name: 'setup',
  setup(__props) {

const whitelist = reactive({ 
  ipwhitelist: "",
  apiWhitelist: "",  
  })
  


  const addWhitelist=()=>{ 
    addConfig(JSON.stringify(whitelist)).then((res: any) => {
          if (res != "" && res.code == 0) { 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })


  }

  getConfig().then((res: any) => {
          if (res != "" && res.code == 0) { 
            whitelist.ipwhitelist=res.data.ipwhitelist;
            whitelist.apiWhitelist=res.data.apiWhitelist; 
          }
        })

 


//节点分类
const loading = ref(false);
  


  const orderId = ref("");


const  dealWithOrder=()=>{
  if(orderId.value.length<=3){
    layer.msg("请输入异常订单号")
    return;
  }
  var data={key:orderId.value};

  abnormalOrders(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) { 
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })

}



  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "id", key: "id", align: "center" },
    { title: "名称", key: "name", align: "center" },
    { title: "app下载地址", key: "appUrl", align: "center"},
    { title: "苹果书签", key: "webUrl", align: "center"},
    { title: "苹果app", key: "iosUrl", align: "center"},
    { title: "是否通知", key: "type", align: "center", customSlot: "type"},
    { title: "通知地址", key: "notificationAddress", align: "center"},
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  const getAllPlatform = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit};
    allPlatform(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllPlatform();


  const change = (page: any) => {
    getAllPlatform();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
 

  
  const platform = reactive({
    id:0,
    name: "",
    appUrl: "", 
    webUrl: "", 
    iosUrl: "", 
    type: 0, 
    notificationAddress: "", 
  })
  
 

  
  const updatePassageCategory = (row: any) => {
    platform.id = row.id;
    platform.name = row.name;
    platform.appUrl = row.appUrl;
    platform.webUrl = row.webUrl;
    platform.iosUrl = row.iosUrl;
    platform.type = row.type;
    platform.notificationAddress = row.notificationAddress;
  
    visible11.value = !visible11.value;
  }
  
  const layFormRef11 = ref();
  
  const visible11 = ref(false);
   
  
  const changePassageCategory = () => {
    platform.id = 0;
    platform.name = "";
    platform.appUrl = "";  
    platform.webUrl = "";  
    platform.iosUrl = "";  
    platform.type = 0;  
    platform.notificationAddress = "";  
    visible11.value = !visible11.value;
  }
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        if(platform.type==0){
          platform.notificationAddress = "";  
        }
        addPlatform(JSON.stringify(platform)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllPlatform();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false;
  
  
      }
    }
  ])

  

return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_space = _resolveComponent("space")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_field = _resolveComponent("lay-field")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_radio = _resolveComponent("lay-radio")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "平台" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_lay_button, {
                        size: "sm",
                        onClick: changePassageCategory,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("新增")
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode(_component_lay_table, {
                      page: page,
                      height: '100%',
                      columns: columns.value,
                      loading: loading.value,
                      "data-source": dataSource.value,
                      "selected-keys": selectedKeys.value,
                      "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                      onChange: change,
                      onSortChange: sortChange
                    }, {
                      operator: _withCtx(({ row }) => [
                        _createVNode(_component_lay_button, {
                          size: "xs",
                          type: "primary",
                          onClick: ($event: any) => (updatePassageCategory(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      type: _withCtx(({ row }) => [
                        (row.type==0)
                          ? (_openBlock(), _createBlock(_component_space, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 不通知 ")
                              ]),
                              _: 1
                            }))
                          : (row.type==1)
                            ? (_openBlock(), _createBlock(_component_space, { key: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 通知 ")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "异常订单处理" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_form_item, {
                          label: "订单号",
                          prop: "orderId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_input, {
                              modelValue: orderId.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderId).value = $event)),
                              placeholder: "请输入异常订单号"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_button, {
                              type: "primary",
                              onClick: dealWithOrder
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("提交")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_lay_col, { md: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_field, { title: "放行接口白名单" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form, { model: whitelist }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_form_item, {
                          label: "IP白名单",
                          prop: "ipwhitelist"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_textarea, {
                              placeholder: "请输入白名单（多个逗号隔开）",
                              modelValue: whitelist.ipwhitelist,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((whitelist.ipwhitelist) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, {
                          label: "白名单接口",
                          prop: "apiWhitelist"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_textarea, {
                              placeholder: "请输入白名单接口（多个逗号隔开）",
                              modelValue: whitelist.apiWhitelist,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((whitelist.apiWhitelist) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_lay_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_button, {
                              type: "primary",
                              onClick: addWhitelist
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("提交")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['350px', '380px'],
      btn: action11.value,
      title: "添加/修改平台"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: platform,
            ref_key: "layFormRef11",
            ref: layFormRef11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "名称",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((platform.name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "app下载地址",
                prop: "appUrl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.appUrl,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((platform.appUrl) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "苹果书签",
                prop: "webUrl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.webUrl,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((platform.webUrl) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "苹果app",
                prop: "iosUrl"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: platform.iosUrl,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((platform.iosUrl) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "是否通知",
                prop: "type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_radio, {
                    modelValue: platform.type,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((platform.type) = $event)),
                    name: "type",
                    value: 0,
                    label: "不通知"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_lay_radio, {
                    modelValue: platform.type,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((platform.type) = $event)),
                    name: "type",
                    value: 1,
                    label: "通知"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (platform.type==1)
                ? (_openBlock(), _createBlock(_component_lay_form_item, {
                    key: 0,
                    label: "通知地址",
                    prop: "notificationAddress"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_input, {
                        modelValue: platform.notificationAddress,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((platform.notificationAddress) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})